import React from 'react';
import PropTypes from 'prop-types';
import EvaluationSentCompactDialogView from '@fingo/lib/features/factoring/views/EvaluationSentCompactDialogView';
import { chileTitles as evaluationSentTitles } from '@fingo/lib/constants/factoring/evaluation-sent-titles';

const EvaluationSentDialog = ({
  open,
  onClose,
  warningMessage,
}) => (
  <EvaluationSentCompactDialogView
    open={open}
    onClose={onClose}
    title={evaluationSentTitles.title}
    description={evaluationSentTitles.description}
    acceptButtonLabel="VER FACTURAS EN EVALUACIÓN"
    warningMessage={warningMessage}
  />
);

EvaluationSentDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  warningMessage: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }),
};

EvaluationSentDialog.defaultProps = {
  warningMessage: null,
};

export default EvaluationSentDialog;
